import React from 'react';
import PropTypes from 'prop-types';
import utils from 'web3-utils';
import { noop } from 'lodash';
import AddressImage from '@blockcatio/tabby-library/lib/components/AddressImage';
import { CopyToClipboard } from 'react-copy-to-clipboard';

const PaymentAddress = ({ address, onCopy }) => {
  if (address) {
    const checksumAddress = utils.toChecksumAddress(address);
    const shortAddress = `${checksumAddress.substr(0, 6)}...${checksumAddress.substr(-6)}`;
    return (
      <CopyToClipboard text={checksumAddress} onCopy={onCopy}>
        <div title="Click to copy" className="copy-tooltip">
          <span className="address">{shortAddress}</span>
          <AddressImage address={address} />
        </div>
      </CopyToClipboard>
    );
  }
  return null;
};

PaymentAddress.displayName = 'PaymentAddress';

PaymentAddress.defaultProps = {
  onCopy: noop,
};

PaymentAddress.propTypes = {
  address: PropTypes.string.isRequired,
  onCopy: PropTypes.func,
};

export default PaymentAddress;



// WEBPACK FOOTER //
// ./src/components/PaymentAddress.js